import React, { useMemo } from 'react'
import Modal from 'react-bootstrap/Modal'
import { Button } from 'react-bootstrap';
import { changeStatusPeriodeKurban } from '../../../../_redux/periode-kurban/periodeKurbanCrud';
import { toast } from 'react-toastify';
import { toastOption } from '../../../../../../../_metronic/_helpers';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../../_redux/periode-kurban/periodeKurbanAction';
import { usePeriodeKurbanUIContext } from '../PeriodeKurbanUIContext';

function PeriodeKurbanStatusModal({ show, handleClose, data }) {
  const dispatch = useDispatch();
  const periodeKurbanUIContext = usePeriodeKurbanUIContext();
  const periodeKurbanUIProps = useMemo(() => {
    return {
      queryParams: periodeKurbanUIContext.queryParams,
    };
  }, [periodeKurbanUIContext]);

  const postData = () => {
    changeStatusPeriodeKurban(data.uuid, data.is_active ? "inactive" : "active").then((response) => {
      toast.success(response.data.message, toastOption)
      dispatch(actions.fetchPeriodeKurbans(periodeKurbanUIProps.queryParams));
      handleClose()
    }).catch((error) => {
      toast.error(error.response.data.message, toastOption)
      dispatch(actions.fetchPeriodeKurbans(periodeKurbanUIProps.queryParams));
      handleClose()
    })
  }

  return (
    <>
      {data && <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Ubah Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Apakah anda yakin akan {data.is_active ? "Menonaktifkan" : "Mengaktifkan"} Periode Kurban ini ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Batal
          </Button>

          <Button variant="primary" onClick={() => {
            postData()
          }}>Yakin</Button>
        </Modal.Footer>
      </Modal>}
    </>
  );
}

export default PeriodeKurbanStatusModal